/* Domains: search for a name. Registration is not built yet, and the page
 * says so instead of offering a button that does nothing. */
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

import { api } from "../api";

interface Availability {
  sld: string;
  tld: string;
  available: boolean;
}

export function Domains() {
  const [sld, setSld] = useState("");
  const [tld, setTld] = useState("co.za");

  const search = useMutation({
    mutationFn: () =>
      api.get<Availability>(
        `/api/domains/search?sld=${encodeURIComponent(sld.trim().toLowerCase())}&tld=${encodeURIComponent(tld.trim().toLowerCase())}`,
      ),
  });

  return (
    <section>
      <div className="page-head">
        <div>
          <p className="label">Domains</p>
          <h1>Find a domain</h1>
        </div>
      </div>

      <form
        onSubmit={(event) => {
          event.preventDefault();
          if (sld.trim()) search.mutate();
        }}
      >
        <input
          value={sld}
          onChange={(event) => setSld(event.target.value)}
          placeholder="mybusiness"
          aria-label="Name"
        />
        <input value={tld} onChange={(e) => setTld(e.target.value)} aria-label="Extension" />
        <button type="submit" disabled={search.isPending || !sld.trim()}>
          Search
        </button>
      </form>
      {search.isError && <p className="bad">{(search.error as Error).message}</p>}
      {search.data && (
        <p className={search.data.available ? "ok" : "warn"}>
          {search.data.sld}.{search.data.tld} is {search.data.available ? "available" : "taken"}.
        </p>
      )}
      <p className="muted">
        Registering a domain from this page is not available yet. Availability search only.
      </p>
    </section>
  );
}
